import { TabTemplateDetails } from '../../tab-template-details/TabTemplateDetails';
import type { TabTemplateDetailsEntity } from '../../tab-template-details/TabTemplateDetails.entity';
import type { TRenderScreen } from '../SettingsScreenRendererService';

export function renderTabTemplatesDetailsScreen(screen: TabTemplateDetailsEntity): TRenderScreen {
  return () => <TabTemplateDetails screen={screen} />;
}
